module.exports = __webpack_public_path__ + "static/media/italiano_icona_costo.e329a17a.png";